import { DeviceInfo, OptionInfo } from '@/types/api/v1/CustomerInfoResponse';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

export type CustomerInfoStateType = {
  // 顧客情報照会
  contractInfo: {
    state: string;
    stateName: string;
    planCode: string;
    planName: string;
    serviceStartDate: string;
    iotServiceNo: string;
  };
  optionInfos: OptionInfo[];
  deviceInfos: DeviceInfo[];
  existProvideService: boolean;
  isOrderProcessing: boolean;
  paymentType: string;
  planContinuedUseInfo: {
    planContinuedUseFlg: string;
    planContinuedUseTarget: string;
  };
};

export const CustomerInfoState = atom<CustomerInfoStateType>({
  key: 'CustomerInfoState',
  default: {
    // 顧客情報照会
    contractInfo: {
      state: '',
      stateName: '',
      planCode: '',
      planName: '',
      serviceStartDate: '',
      iotServiceNo: '',
    },
    optionInfos: [],
    deviceInfos: [],
    existProvideService: true,
    isOrderProcessing: true,
    paymentType: '',
    planContinuedUseInfo: {
      planContinuedUseFlg: '',
      planContinuedUseTarget: '',
    },
  },
  effects_UNSTABLE: [persistAtom],
});

export default CustomerInfoState;
